import React from 'react';
import ErrorIcon from "../../assets/error.inline.svg";

const FormField = ({ 
  label, 
  id, 
  name, 
  value, 
  onChange, 
  placeholder, 
  error,
  additionalError,
  type = 'text'
}) => {
  const hasError = error || additionalError;
  
  return (
    <div className={`solicitor-panel-checker-form__form-group ${hasError ? 'solicitor-panel-checker-form__form-group--error' : ''}`}>
      <label htmlFor={id} className="solicitor-panel-checker-form__label">
        {label}
      </label>
      <input
        onChange={onChange}
        value={value}
        className="solicitor-panel-checker-form__input"
        type={type}
        id={id}
        name={name}
        placeholder={placeholder}
      />
      {error && <p className="solicitor-panel-checker-form__error"><ErrorIcon /> {error}</p>}
      {additionalError && <p className="solicitor-panel-checker-form__error"><ErrorIcon /> {additionalError}</p>}
    </div>
  );
};

export default FormField;
